import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';
import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';
import { TListResponse } from 'src/common/types';


export const AccountClientContactListSortCol = {
	ID: 'id',
	PHONE_NUMBER: 'phone_number',
	EMAIL: 'email',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TAccountClientContactListSortCol = TTableSortCols<typeof AccountClientContactListSortCol>;

export type TAccountClientContactListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TAccountClientContactListSortCol;
};

export type TAccountClientContactQueryPayload = {
	clientId: number;
	data?: TAccountClientContactListQuery;
};

export type TAccountClientContactQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountClientContactQueryToRequest(data: TAccountClientContactListQuery): TAccountClientContactQueryRequest {
	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountClientContact = {
  id: number;
  clientId: number;
  description?: string;
  phoneNumber?: string;
  email?: string;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TAccountClientContactResponse = {
  id: number;
  client_id: number;
  description?: string;
  phone_number?: string;
	email?: string;
  created_at: string;
  updated_at: string;

	created_by: TUserMetaResponse;
	updated_by: TUserMetaResponse;
};

export type TAccountClientContactListResponse = TListResponse<TAccountClientContactResponse>;

export type TAccountClientContactList = TListResponse<TAccountClientContact>;

export type TAccountClientContactBodyRequest = {
	description?: string;
	phoneNumber?: string;
	email?: string;
};

export type TAccountClientContactRequest = {
	description?: string;
	phone_number?: string;
	email?: string;
};

export type TAccountClientContactPayloadParams = {
	id: number;
	clientId: number;
};

export type TAccountClientContactPayloadCreate = {
	clientId: number;
	data: TAccountClientContactBodyRequest;
};

export type TAccountClientContactPayloadUpdate = TAccountClientContactPayloadCreate & {
	id: number;
};

export function adaptAccountClientContactFromListResponse(data: TAccountClientContactListResponse): TAccountClientContactList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptAccountClientContactFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptAccountClientContactFromResponse(data: TAccountClientContactResponse): TAccountClientContact {
	const {
		id,
		client_id: clientId,
		description,
		phone_number: phoneNumber,
		email,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
		created_at: createdAt,
		updated_at: updatedAt,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		clientId,
		description,
		phoneNumber,
		email,
		createdBy,
		updatedBy,
		createdAt,
		updatedAt,
	};
}

export function adaptAccountClientContactToRequest(data: TAccountClientContactBodyRequest): TAccountClientContactRequest {
	const {
		description = undefined,
		phoneNumber = undefined,
		email = undefined,
	} = data;

	return {
		description,
		phone_number: phoneNumber,
		email,
	};
}
